module.exports = __webpack_public_path__ + "static/custompropdef2-6174399f2861d9561098a12d7be273d1.png";